<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid>
    <v-layout align-center justify-center row>
      <v-flex xs10>
        <v-container fluid grid-list-md>
          <v-layout row justify-center align-center>
            <whatsapp-package-card v-for="(item, i) in data" :key="`${item.id}-${i}`" :item="item">
              <template v-slot:pricing-btn>
                <button class="main-btn mb-3" @click="getOffer(item)">
                  Talep Oluştur
                </button>
                <div>
                  <button class="main-btn eft-btn mb-3" @click="goToBankAccounts">
                    Havale/EFT ({{ item.tutar }} TL)
                  </button>
                  <!-- <button class="main-btn credit-btn" @click="buyPack(item)">
                    Kredi Kartı ({{ item.kredi_karti_tutar }} TL)
                  </button> -->
                </div>

              </template>
            </whatsapp-package-card>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <pluggable-as-dialog max-width="450">
      <template v-slot:content>
        <v-card flat color="transparent">
          <v-card-title class="headline">
            Hesabınız aktif değil!
          </v-card-title>
          <v-card-text>
            Paket satın alabilmek için hesabınızı aktif etmelisiniz.
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn depressed color="primary" @click.stop="$trigger('setPluginDialog')">
              Kapat
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </pluggable-as-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import checkWebsite from '@/mixins/computed/check-website';
import WhatsappPackageCard from '../../Components/WhatsappPackageCard.vue';
import PluggableAsDialog from '../../Components/Pluggable/PluggableAsDialog.vue';

export default {
  name: 'WhatsappPrices',
  components: {
    PluggableAsDialog,
    WhatsappPackageCard,
  },
  mixins: [checkWebsite],
  data: () => ({
    data: [],
  }),
  methods: {
    goToBankAccounts() {
      if (this.$store.state.user.confirmation === '4') {
        this.$trigger('setPluginDialog');
        return;
      }
      this.$router.push('/bank/accounts');
    },
    getOffer(pack) {
      this.send({
        route: 'packet',
        data: {
          id: pack.id,
          site: this.isVatan ? 'vatansms.net' : 'toplusmspaketleri.com',
        },
      }).then(() => {

      });
    },
    buyPack(pack) {
      this.send({
        route: 'whatsapp/buy',
        data: { id: pack.id }
      })
        .then((res) => {
          this.$router.push({ name: 'whatsapp.payments.card', params: { payCredit: res.data.data } });
        });
    },
    ...mapActions({ send: 'sendBackend' }),
    loadData() {
      this.send({ route: 'show/whatsappPrices' })
        .then((res) => {
          this.data = res.data.data;
        });
    },
  },
  created() {
    this.loadData();
  },
};
</script>
